// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { imageStyles } from "@sc/Overrides/Widgets/BrandDetails/BrandDetailsImage";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

imageStyles.container = {
    css: css`
        margin: 15px 0;
    `,
};

imageStyles.productLinkItem = {
    width: 12,
    css: css`
        ${xScreen("lte", "md")} {
            justify-content: center;
            text-align: center;
        }
    `,
};

imageStyles.externalLinkItem = {
    width: 12,
    css: css`
        ${xScreen("lte", "md")} {
            justify-content: center;
            text-align: center;
        }
    `,
};

imageStyles.externalLink = {
    css: css`
        padding: 12px 32px;
    `,
};

imageStyles.productButton = {
    css: css`
        padding: 12px 32px;
    `,
};
